/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  SettingsService,
  ISettingsMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
  IInviteUserMethods,
  InviteUserService,
  IDeleteUserMethods,
  DeleteUserService,
  IReInviteUserMethods,
  ReInviteUserService,
  ISuspendUserMethods,
  SuspendUserService,
  ActivateUserService,
  IActivateUserMethods,
  IMasqueraderListMethods,
  MasqueraderListService
} from "./components";

export type MasqueraderListPageAgent = IHeaderMethods &
  ISettingsMethods &
  IStaticPageContentMethods &
  IInviteUserMethods &
  IReInviteUserMethods &
  ISuspendUserMethods &
  IActivateUserMethods &
  IDeleteUserMethods & IMasqueraderListMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new HeaderService(),
    new SettingsService(),
    new InviteUserService(),
    new DeleteUserService(),
    new ReInviteUserService(),
    new SuspendUserService(),
    new ActivateUserService(),
    new MasqueraderListService()
  ];
};

export const getAgent = () => {
  return createAgent<MasqueraderListPageAgent>({
    plugins: getPlugins(),
  });
};
